module.exports = __webpack_public_path__ + "img/success.4f8357f7.svg";